import { useTranslation } from 'react-i18next'
import React from 'react'

import { Col, Grid } from '../../../packages/kiti/components/structure/Grid'
import { Title } from '../../../packages/kiti/components/presentation/Text'
import { useCloseModal } from '../../../components/modals/ModalsContext'
import Icon from '../../../packages/kiti/components/shapes/Icon'
import Line from '../../../packages/kiti/components/helpers/Line'
import Separator from '../../../packages/kiti/components/helpers/Separator'

const ModalHeader = () => {
  const { t } = useTranslation('editAsset')
  const onClose = useCloseModal()

  return (
    <>
      <Separator paddingV={1.7} paddingH={2}>
        <Grid justify="space-between">
          <Col flex={1}>
            <Title size="h5" noMargin>
              {t('bulkRegister')}
            </Title>
          </Col>
          <Col>
            <Icon name="BsX" onClick={onClose} size={1.5} color="dark1" />
          </Col>
        </Grid>
      </Separator>
      <Line />
    </>
  )
}

export default ModalHeader
